const partnerApi = {
    getReview: async (token) => {
        const res = await fetch(`/api/partner/review/${token}`, {
            headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) return null;
        return res.json();
    },

    submitDecisions: async (token, decisions) => {
        const res = await fetch(`/api/partner/review/${token}/decisions`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ decisions }),
        });
        return res.ok;
    },
};

export default partnerApi;
